import {
  PRODUCTS_PREPAID,
  PRODUCTS_PREPAID_ERROR,
  CLEAN_PRODUCTS_PREPAID,
  CLEAN_PRODUCTS_PREPAID_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function productsPrepaidReducer(state = initialState, action) {
  switch (action.type) {
    case PRODUCTS_PREPAID:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case PRODUCTS_PREPAID_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_PRODUCTS_PREPAID:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_PRODUCTS_PREPAID_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
